var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberEight = function SvgIconNumberEight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.497 9.719a2.41 2.41 0 0 1 2.42-2.42 2.41 2.41 0 0 1 2.419 2.42c0 .747-.347 1.454-.9 1.909.902.515 1.47 1.486 1.47 2.59 0 .796-.26 1.545-.78 2.099-.523.558-1.28.884-2.203.884s-1.679-.326-2.203-.884c-.52-.554-.778-1.303-.778-2.098 0-1.118.58-2.1 1.501-2.61a2.35 2.35 0 0 1-.946-1.89m2.553 1.52-.12-.002c-.873-.056-1.532-.707-1.532-1.518 0-.841.665-1.518 1.518-1.518.854 0 1.518.677 1.518 1.518 0 .823-.638 1.5-1.384 1.52m-.145.9c-1.208.009-2.062.927-2.062 2.08 0 .602.195 1.119.534 1.481.336.358.845.6 1.546.6s1.21-.242 1.546-.6c.34-.362.535-.879.535-1.481 0-1.12-.807-2.02-1.962-2.078q-.068 0-.137-.003",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 1c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberEight;